import ExpedientForm from "./form";
import { AttendanceLocal } from "../../../../../../../@types/attendance-local";
import { useAttendanceLocalExpedientUpdate } from "../../../../../../../services/api-tansquery/attendance-local/expedient/update";

type ExpedientFormProps = {
    slug: string;
    expedient: AttendanceLocal["horario_unidade"];
    buttonTrigger?: React.ReactNode;
};

export default function ExpedientFormUpdate(props: ExpedientFormProps) {
    const mutation = useAttendanceLocalExpedientUpdate(props.expedient.id);

    return (
        <ExpedientForm
            {...props}
            mutation={mutation}
        />
    );
}
